<template>
  <div></div>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    const applicationId = this.$route.query.applicationId.toString();
    const applicationUserId = this.$route.query.applicationUserId.toString();

    console.log(applicationId, applicationUserId);

    axios
      .post("/links", { applicationId, applicationUserId })
      .then(response => {
        window.location = response.data;
      })
      .catch(err => {
        console.log(err.response);
      });
  }
};
</script>